const sectors = {
  etf: [
    "spy",
    "upro",
    "xlk",
    "vgt",
    //"igv",
    "qld",
    //"xsw",
    //"hack",
    // "bug",
    //"clou",
    //"finx",
    //"iyt",
    //"xtn",
    //"xar",
    "xlp",
    "iyc" /*, 'xlf', 'ibb'*/,
    //"fxy",
    //"tlt",
    //"govt",
  ],
  fang: [
    "aapl",
    "amzn",
    "googl",
    "msft",
    "isrg",
    "meta",
    "tsla",
    "orcl",
    "nflx",
    "cost",
    "pltr",
    "nvda",
  ],
  semi: [
    "usd",
    "soxx",
    "xsd",
    "nvda",
    "amd",
    "avgo",
    "mrvl",
    "gfs",
    "cbrs",
    "spcx",

    "asml",
    "amat",
    "lrcx",
    "ewt",
    "tsm",
    "tsem",

    "mu",
    "sndk",
    "wdc",
    "stx",
    "ntap",
    "pstg",

    "intc",
    "qcom",
    "csco",
    "anet",
    "ibm",
    "dell",
    "nok",

    "klac",
    "ateyy",
    "ter",
    "aehr",
    "form",
    "amkr",
    "ttmi",

    "etn",
    "powl",
    "vrt",
    "nvt",
    "mpwr",
    "nvts",
    "vicr",
    "hubb",
    "be",
    "tmdx",
    "ifnny",
    "stm",
    "adi",
    "mchp",
    "wolf",
    "on",
    "azz",
    "ceg",

    "lite",
    "cohr",
    "cien",
    "lasr",
    "aaoi",
    "glw",

    "crwv",
    "nbis",
    "iren",
    "docn",

    "rmbs",
    "arm",

    "ionq",
    "qbts",
    "rgti",
    "qubt",

    "amsc",
    "smci",
    "hpe",
    "nxpi",
    "txn",
    "snps",
    "cdns",

    "mbly",

    "cat",
    "crdo",
    "keys",
  ],
  "semi-chip": [
    "nvda",
    "amd",
    "arm",
    "avgo",
    "mrvl",
    "intc",
    "gfs",
    "rmbs",
    "cbrs",
    "crdo",
  ],
  "semi-storage": ["mu", "sndk", "wdc", "stx", "pstg", "lrcx", "amat"],
  //"semi-cpu": ["amd", "intc", "arm"],

  "semi-equipment": [
    "tsm",
    "asml",
    "amat",
    "lrcx",
    "klac",
    "ter",
    "ateyy",
    "aehr",
    "form",
    "amkr",
  ],

  "semi-power": [
    "powl",
    "nvt",
    "etn",
    "vrt",
    "on",
    "mpwr",
    "nvts",
    "vicr",

    "ifnny",
    "stm",
    "adi",
    "mchp",
    "wolf",

    "amsc",
    "be",
    "azz",
    "ceg",
    "ttmi",
    "cat",
  ],
  "semi-network": [
    "csco",
    "anet",
    "nok",
    "cien",
    "mrvl",
    "lite",
    "cohr",
    "cien",
    "lasr",
    "aaoi",
    "glw",
    "crdo",
  ],
  "semi-test": ["ateyy", "ter", "klac", "aehr", "form", "keys"],
  "semi-traditional": ["qcom", "txn", "tsem", "nxpi"],
  "semi-tw": ["tsm", "tsem", "ewt"],

  "semi-data-center": ["crwv", "nbis", "iren", "docn", "crdo"],
  //"semi-network": [],
  "semi-server": ["dell", "smci", "hpe", "ntap"],

  "semi-eda": ["snps", "cdns"],
  "semi-quantum": ["ionq", "qbts", "rgti", "qubt", "ibm"],

  "software-bit": [
    "bito",
    "gbtc",
    "mstr",
    "coin",
    "crcl",
    "spbc",
    "biti",
    "hood",
    "bull",
  ],
  bond: ["fxy", "tlt", "govt", "mo", "crcl", "bti"],
  /*
  "etf-tech": [
    "xlk",
    "igv",
    "vgt",
    "xsw",
    "hack",
    "bug",
    "clou",
    "botz",
    //"xsd",
    //"soxx",
    //"ipo",
    //"arkk",
  ],
  */

  software: [
    "aapl",
    "amzn",
    "googl",
    "msft",
    "isrg",
    "meta",
    "tsla",
    "orcl",
    "nflx",
    "cost",
    "pltr",

    "igv",
    "xsw",
    "orcl", //"box",
    "adbe",
    "wday",
    "crm",
    "now",
    "sap",
    //"splk",
    "ddog",
    "snow",
    "team",
    "twlo",
    "mdb",
    "estc",
    "pltr",

    "hack",
    "bug",
    "panw",
    "zs",
    "ftnt",
    "cybr",
    "chkp",
    "crwd",
    "net",
    //"ktos",
    "okta",
    "akam",

    "mstr",
    "coin",
    "crcl",

    "ipo",
    "arkk",
    "iwm",
    "rblx",
    "app",
    "u",
    "spot",
    "zm",
    "duol",
    "evgo",

    "uber",
    "dash",
    "lyft",
    "cart",
    "yelp",
    "pins",
    "rddt",
    "hims",
    "snap",
    //"djt",

    "botz",
    "ai",
    "soun",
    "bbai",
    "sym",
    "syk",

    "finx",
    "shop",
    "upst",
    "afrm",
    "hood",
    "bull",
    "sofi",
    "pgy",
    "xyz",
    "pypl",
    "ebay",
    "docu",
    "adp",
    "intu",
    "payx",
    "payc",
    "efx",
    "v",
    "ma",
    "axp",
  ],

  "software-fang": [
    "aapl",
    "amzn",
    "googl",
    "msft",
    "isrg",
    "meta",
    "tsla",
    "orcl",
    "nflx",
    "cost",
    "pltr",
    "nvda",
  ],

  "software-enterprise": [
    "igv",
    "xsw",
    "clou",
    "orcl", //"box",
    "adbe",
    "wday",
    "crm",
    "now",
    "sap",
    "pltr",
    "zm",
    //"splk",
    "ddog",
    "snow",
    "team",
    "twlo",
    "mdb",
    "docu",
    "okta",
    "akam",
    "estc",
    "adsk",
    //"newr",
    //"vmw",
  ],
  "software-security": [
    "hack",
    "bug",
    "panw",
    "zs",
    "ftnt",
    "cybr",
    "chkp",
    "crwd",
    "net",
    //"ktos",
    "okta",
    "akam",
  ],
  "software-new-ipo": [
    "ipo",
    "arkk",
    "iwm",
    "app",
    "rblx",
    "u",
    "spot",
    "zm",
    "duol",
    "evgo",
    "hims",
  ],
  "software-gig": ["uber", "dash", "lyft", "cart", "yelp"],
  "software-social": ["meta", "rddt", "snap", "spot", "pins"],
  "software-ecommerce": ["ebay", "meli", "cpng", "baba"],
  "software-ai": [
    "botz",
    "ai",
    "soun",
    "bbai",
    "sym",
    "syk",
    //"upst",
    //"bidu",
    // "tsp",
  ],
  "software-av": [
    "aur",
    "mbly",
    "lazr",
    "tsla",
    /*"rivn", "lcid",*/ "nio",
    "li",
    "xpev",
  ],

  "software-fintech": [
    "finx",
    "shop",
    "hood",
    "bull",
    "sofi",
    //"mstr",
    "xyz",
    "pgy",
    "pypl",
    "ebay",
    "docu",
    //"adp",
    "intu",
    //"payx",
    //"payc",

    //"efx",
    //"v",
    //"ma",
    //"axp",
  ],

  "software-payroll": ["adp", "payx", "payc"],

  "software-cc": ["efx", "v", "ma", "axp"],

  "software-rate": ["upst", "afrm", "tlt", "govt"],

  bank: [
    "xlf",
    "bac",
    "c",
    "jpm",
    "blk",
    "ms",
    "gs",
    "wfc",
    "fis",
    "schw",
    "kre",
    "kbe",
    "kbwb",
  ],

  credit: ["axp", "ma", "v", "efx", "intu"],

  realty: [
    "schh",
    "iyr",
    "reet",
    "wood",
    "ifra",
    "xlu",
    "hd",
    "low",

    "z",
    "w",
    "bx",
    "cut",
    "kkr",
    "usrt",
    "xhb",

    "itb",
    "dhi",
    "tol",
    "kbh",
    "len",
    "sum",
  ],

  "realty-home": [
    "schh",
    "iyr",
    "reet",
    "wood",
    "itb",
    "ifra",
    "xlu",
    "hd",
    "low",
    "z",
    "w",
    //"rdfn",
  ],
  "realty-builder": ["itb", "xhb", "dhi", "tol", "kbh", "len", "wood", "sum"],

  "software-oldtech": ["dis", "mtch", "ea"],
  "software-small": [
    "roku",
    //"ddd",
    "gme",
    //"ostk",
    //"bb",
    //"net",
    //"bigc",
    //"work",
    //"dbx",
    //"svmk",
    //"sumo",
    //"twtr",
    //"snap",
    //"pins",
    //"pd",
    //"smar",
    //"ride",
    //"wkhs",
    //"wish",
    //"pets",
    //"dkng",
    //"sklz",
    //"fsly",
    //"fubo",
    //'grpn', 'gpro',
  ],

  travel: [
    "jets",
    "ual",
    "dal",
    "aal",
    "skyw",
    "luv",
    "ba",

    "nclh",
    "ccl",
    "cuk",
    "rcl",

    "bkng",
    "expe",
    "trip",

    "hlt",
    "mar",
    "h",

    "abnb",

    "lvs",
    "wynn",

    "yelp",

    "iyt",
    "xtn",
    "gm",
    "f",
    "ups",
    "fdx",
    "pcar",
    "azo",
    "cvna",
    "car",
    "htz",

    "uber",
    "lyft",
  ],

  "travel-flight": [
    "jets",
    "ual",
    "dal",
    "aal",
    "skyw",
    "luv",
    "ba",
    "nclh",
    "ccl",
    "cuk",
    "rcl",
  ],
  "travel-cruise": ["nclh", "ccl", "rcl"],

  "travel-trip": [
    "bkng",
    "expe",
    "trip",

    "hlt",
    "mar",
    "h",

    "abnb",

    "lvs",
    "wynn",

    "yelp",
  ],
  "travel-trans": [
    "iyt",
    "xtn",
    "gm",
    "f",
    "ups",
    "fdx",
    "pcar",
    "azo",
    "cvna",
    "car",
    "htz",
    "ccl",
    "nclh",
    "uber",
    "lyft",
  ],

  material: [
    "iym",
    "xlb",
    "ifra",
    "aa",
    "cenx",
    "bdry",
    "boat",
    "clf",
    "mp",

    "gld",
    "nugt",
    "gdx",
    "slv",
    "silj",
    "pplt",
    "scco",
    "copx",
    "cper",
  ],

  "material-precious": [
    "gld",
    "nugt",
    "gdx",
    "slv",
    "silj",
    "pplt",
    "scco",
    "copx",
    "cper",
    "aa",
    "cenx",
    "clf",
  ],

  "material-materialO": [
    "iym",
    "xlb",
    "ifra",
    "aa",
    "cenx",
    "bdry",
    "boat",
    "clf",
    "mp",
  ],

  energy: [
    "uso",
    "oilk",
    "ieo",
    "xle",
    "vde",
    "pxe",
    "xom",
    "oxy",
    "cvx",
    "cop",
    "vlo",
    "mpc",
    "psx",
    "mur",
    "ksa",
    "nfg",
    "ung",
    "bwet",
    "bwxt",
    "unl",
  ],

  "energy-energyO": [
    "uso",
    "oilk",
    "ieo",
    "xle",
    "vde",
    "pxe",
    "xom",
    "oxy",
    "cvx",
    "cop",
    "vlo",
    "mpc",
    "psx",
    "mur",
    "ksa",
    "nfg",
    "ung",
  ],

  "energy-refine": ["vlo", "mpc", "psx"],
  "energy-nuclear": ["bwxt", "nne", "oklo", "smr", "leu", "uec"],
  "energy-lit": ["lit", "batt", "alb", "lac"],
  "energy-solar": [
    "tan",
    "smog",
    "enph",
    "fslr",
    "te",
    "run",
    "nxt",
    "csiq",
    //"spwr",
    //"nova",
    "jks",
  ],

  defence: [
    "xar",
    "pltr",
    "lmt",
    "ge",
    "hon",
    "noc",
    "rtx",
    "gd",
    "hii",
    "hwm",
    "cw",
    "cat",
    "ktos",
  ],

  "defense-space": [
    "rklb",
    "asts",
    "hwm",
    "pl",
    "vcx",
    "dxyz",
    "spce",
    /*
    "ktos",
    "rcat",
    "onds",
    "umac",
    "avav",
    */
  ],

  "defense-drone": ["ktos", "rcat", "onds", "umac", "avav"],
  //"defense-spaceX": ["rklb", "asts",],

  "etf-international": [
    "ewj",
    "ewy",
    "inda",
    "vnm",
    "ewt",
    "ksa",
    "vgk",
    "mxf",
  ],

  china: [
    "fxi",
    "ashr",
    "mchi",
    "kweb",
    "fxp",
    "bidu",
    "ntes",
    "baba",
    "jd",
    "pdd",
    "bili",
    "futu",
    "nio",
    "li",
    "xpev",
    "edu",
    "se",
    "amc",
  ],

  bio: [
    "ibb",
    "xbi",
    "xlu",

    "isrg",
    "syk",
    "hims",

    "mrk",
    "amgn",
    "lly",
    "nvo",
    "mo",
    "bti",
    "unh",
    "jnj",
    "abbv",
    "bmy",
    "gsk",
    "dow",
    "cvs",
    "wba",
    "pfe",
    //"ogn",
    "gild",
    "mrna",
    "bntx",
    "nvax",
    "sny",
    "biib",

    //"hlf",
    //"nus",
    //"nktr","ntla","edit","fit","bmy",
  ],
  "bio-weight-control": ["lly", "nvo"],
  "bio-insurance": ["cvs", "unh"],

  consumer: [
    "xlp",
    "ko",
    "pg",
    "azo",
    //"amzn",
    "wmt",
    "tgt",
    "cvs",
    "wba",
    /*
        "mcd",
        "sbux",
        "cmg",
        "dpz",
        "txrh",
        */
    "bby",
    "iyc",
    "nke",
    "ua",
    "lulu",
    "jwn",
    //"goos",
  ],
  chain: [
    "mcd",
    "cmg",
    "dpz",
    "shak",
    "txrh",
    "sbux",
    "m",
    "jwn",
    "ua",
    "lulu",
    "bby",
  ],

  //cannabis: ["mj", "cron", "cgc", "tlry"],
  av: [
    "tsla",
    "dxyz",
    "spce",
    "aur",
    "mbly",
    "evgo",
    "blnk",
    "lazr",
    "rivn",
    "lcid",
    "nio",
    "li",
    "xpev",
    "chpt",
    "lit",
    "bidu",
  ],
  food: [
    "dba",
    "tags",
    "corn",
    "weat",
    "bal",
    "cane",
    "soyb",
    "jo",
    "mos",
    "ntr",
    "cf",
    "de",
    //"agco",
  ],
  "bio-covid": ["mrna", "bntx", "nvax", "gild", "pfe", "jnj"],
  short: [
    "sh",
    "psq",
    "ssg",
    "rek",
    "sef",
    "sark",
    "sbb",
    "bis",
    "fxp",
    "fxy",
    //"qid",
    //"sdow",
    //"soxs",
    //"skf",
    //"srs",
  ],
  //Favorite: ["pltr", "rddt", "rblx", "oklo"],
};

sectors.software = [
  ...new Set([
    ...sectors.software,
    ...Object.entries(sectors)
      .filter(([sector]) => sector.startsWith("software-"))
      .flatMap(([, symbols]) => symbols),
  ]),
];

export const SectorMap = sectors;
export const AllSectorNames = Object.keys(sectors);
export const AllSymbols = Object.values(SectorMap).flat();

export function getSectorBySymbol(symbol) {
  if (!symbol || typeof symbol !== "string") return null;
  const sym = symbol.toLowerCase();

  for (const [sector, list] of Object.entries(SectorMap)) {
    if (Array.isArray(list) && list.includes(sym)) {
      return sector;
    }
  }
  return null;
}

/**
 * Gets all sectors that contain the symbol, with hyphen handling
 * For sector names like "abc-def", returns "def" (part after hyphen)
 * @param {string} symbol - The symbol to search for
 * @returns {Array<string>} - Array of sector names (processed for hyphens)
 */
export function getSectorsBySymbol(symbol) {
  if (!symbol || typeof symbol !== "string") return [];

  const foundSectors = [];
  const symbolLower = symbol.toLowerCase();

  for (const [sector, symbols] of Object.entries(SectorMap)) {
    if (Array.isArray(symbols) && symbols.includes(symbolLower)) {
      // If sector has hyphen, take the part after the hyphen, otherwise use full name
      const sectorName = sector.includes("-")
        ? sector.split("-").pop()
        : sector;
      foundSectors.push(sectorName);
    }
  }

  return foundSectors;
}

export const isSymbolInSector = (sector, symbol) =>
  sectors[sector] && sectors[sector].includes(symbol);

export const getSymbolsInSector = (sector) => sectors[sector];

export const isSector = (val) => {
  return Object.keys(sectors).includes(val) ? val : "";
};

export const getSectorName = (sector) => {
  const sectorName = sector.replace(/[0-9]/g, "");
  return sectorName;
};

export const findMatchingSectorSymbols = (sectorKey) => {
  if (!sectorKey) return AllSymbols;

  // First try exact match
  if (SectorMap[sectorKey]) {
    return SectorMap[sectorKey];
  }

  // Split SectorMap keys and try to match sectorKey with parts
  const matchingKey = Object.keys(SectorMap).find((key) => {
    const [first, ...rest] = key.split("-");

    // Try to match with remaining parts (after first)
    if (rest.length > 0) {
      const restKey = rest.join("-");
      if (restKey === sectorKey) {
        return true;
      }
    }

    // Try to match with first part only
    if (first === sectorKey) {
      return true;
    }

    return false;
  });

  if (matchingKey) {
    return SectorMap[matchingKey];
  }

  // No match found, return all symbols
  return [];
};

/**
 * Sorts items by sector using the AllSectorNames order
 * @param {Array} items - Array of items with sector property or symbol to lookup sector
 * @param {Function} getSectorFn - Function to get sector from item (optional, defaults to item.sector or getSectorBySymbol)
 * @param {Function} compareWithinSectorFn - Function to sort items within the same sector (optional)
 * @returns {Array} - Sorted array in AllSectorNames order
 */
export const sortBySectorOrder = (
  items = [],
  getSectorFn,
  compareWithinSectorFn,
) => {
  return [...items].sort((a, b) => {
    const sectorA = getSectorFn
      ? getSectorFn(a)
      : a.sector || getSectorBySymbol(a.symbol || a);

    const sectorB = getSectorFn
      ? getSectorFn(b)
      : b.sector || getSectorBySymbol(b.symbol || b);

    const orderA = AllSectorNames.indexOf(sectorA);
    const orderB = AllSectorNames.indexOf(sectorB);

    const sectorCompare =
      (orderA === -1 ? AllSectorNames.length : orderA) -
      (orderB === -1 ? AllSectorNames.length : orderB);

    if (sectorCompare !== 0 || !compareWithinSectorFn) {
      return sectorCompare;
    }

    return compareWithinSectorFn(a, b);
  });
};
